import * as React from 'react'
import { ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { OverlayTrigger } from 'react-bootstrap'
import styles from '../header/Header.module.css'

interface NavItemProps {
  icon: string
  itemText: string
  active: boolean
  onClick: () => void
  className?: string
}

const ListElement: React.FC<NavItemProps> = ({
  icon,
  itemText,
  active,
  className = '',
  onClick,
}) => {
  return (
    <OverlayTrigger placement="right" overlay={<></>}>
      <ListItem
        button
        className={`${window.innerWidth < 900 ? styles.listItemResponsive : ''} ${className}`}
        onClick={onClick}
      >
        <ListItemIcon className={window.innerWidth < 900 ? styles.listItemIconResponsive : ''}>
          <img
            className={
              active
                ? window.innerWidth > 900
                  ? styles.iconActive
                  : styles.iconActiveResponsive
                : window.innerWidth > 900
                ? styles.iconInactive
                : styles.iconInactiveResponsive
            }
            src={icon}
            alt={`${itemText} icon`}
          />
        </ListItemIcon>
        <ListItemText
          className={
            active
              ? window.innerWidth > 900
                ? styles.textActive
                : styles.textActiveResponsive
              : window.innerWidth > 900
              ? styles.textMenu
              : styles.textMenuResponsive
          }
          primary={itemText.toUpperCase()}
        />
      </ListItem>
    </OverlayTrigger>
  )
}

export default ListElement
